/* Synchronize the landing with Releasit's existing offers; the app owns prices and discounts. */
(()=>{
 if(window.GalileaSlimPatch){window.GalileaSlimPatch(document);return;}
 const instances=new WeakMap();
 const money=v=>'$'+Number(v).toLocaleString('es-CL');
 function bindPurchase(root,signal){
  const choices=[...root.querySelectorAll('[data-sp-choice]')];
  const productForm=root.querySelector('.sp-native-buy form[action*="/cart/add"]');
  let quantity=productForm?.querySelector('[name="quantity"]');
  if(productForm&&!quantity){quantity=document.createElement('input');quantity.type='hidden';quantity.name='quantity';productForm.append(quantity);}
  const selected=()=>choices.find(r=>r.checked);
  function display(choice){
   if(!choice)return;
   choices.forEach(r=>{r.checked=r===choice;r.closest('.sp-pack').classList.toggle('is-selected',r.checked);});
   root.querySelectorAll('[data-sp-total]').forEach(el=>el.textContent=money(choice.dataset.price));
   root.querySelectorAll('[data-sp-label]').forEach(el=>el.textContent=choice.dataset.label);
   if(quantity){quantity.value=choice.value;quantity.setAttribute('value',choice.value);quantity.dispatchEvent(new Event('input',{bubbles:true}));quantity.dispatchEvent(new Event('change',{bubbles:true}));}
  }
  let observer,timeout,frame;
  function stop(){observer?.disconnect();observer=null;clearTimeout(timeout);cancelAnimationFrame(frame);}
  const offerQuantity=offer=>offer.querySelector('._rsi-quantity-offers-title')?.textContent.trim().match(/^(\d+)\s*cajas?\b/i)?.[1];
  root.addEventListener('change',event=>{if(event.target.matches('[data-sp-choice]'))display(event.target);},{signal});
  document.addEventListener('click',event=>{
   const target=event.target.closest?.('._rsi-quantity-offers-offer-container');
   if(target?.closest('#_rsi-cod-form-modal-form')){
    stop();display(choices.find(r=>r.value===offerQuantity(target)));return;
   }
   if(event.target.closest?.('#_rsi-cod-form-modal-close')){stop();return;}
   const button=event.target.closest?.('._rsi-buy-now-button');
   if(!button||!(root.contains(button)||button.classList.contains('_rsi-buy-now-button-product-floating')))return;
   stop();display(selected());
   const wanted=selected()?.value;
   function selectOffer(){
    frame=null;
    const modal=document.getElementById('_rsi-cod-form-modal');
    if(!root.isConnected){stop();return;}
    if(!modal?.classList.contains('_rsi-cod-form-modal-open'))return;
    const form=modal.querySelector('#_rsi-cod-form-modal-form');
    const offer=[...(form?.querySelectorAll('._rsi-quantity-offers-offer-container')||[])].find(el=>offerQuantity(el)===wanted);
    if(!offer)return;
    const control=offer.querySelector('._rsi-quantity-offers-offer');
    if(!control)return;
    stop();
    if(!offer.classList.contains('_rsi-quantity-offers-selected'))control.click();
   }
   observer=new MutationObserver(()=>{if(frame==null)frame=requestAnimationFrame(selectOffer);});
   observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});
   frame=requestAnimationFrame(selectOffer);
   timeout=setTimeout(stop,12000);
  },{capture:true,signal});
  display(selected());
  return stop;
 }
 function init(scope){
  const roots=scope.matches?.('[data-sp-product],[data-sp-reviews]')?[scope]:scope.querySelectorAll('[data-sp-product],[data-sp-reviews]');
  roots.forEach(root=>{
   if(instances.has(root))return;
   const abort=new AbortController();const signal=abort.signal;
   const stopPurchase=root.matches('[data-sp-product]')?bindPurchase(root,signal):()=>{};
   root.addEventListener('change',e=>{
    if(e.target.matches('[data-sp-filter]')){
     let shown=0;
     root.querySelectorAll('.sp-review').forEach(card=>{const v=e.target.value;card.hidden=!(v==='all'||v===card.dataset.rating||(v==='photo'&&card.dataset.photo==='true'));if(!card.hidden)shown++;});
     root.querySelector('.sp-empty-filter').hidden=shown>0;
    }
   },{signal});
   root.querySelectorAll('[data-sp-gallery]').forEach(gallery=>{
    const track=gallery.querySelector('[data-gallery-track]');const slides=[...track.querySelectorAll('[data-gallery-slide]')];
    const prev=gallery.querySelector('[data-gallery-prev]'),next=gallery.querySelector('[data-gallery-next]');
    if(!prev||!next||slides.length<2)return;
    let index=0;
    const sync=()=>{index=slides.reduce((best,slide,i)=>Math.abs(slide.offsetLeft-slides[0].offsetLeft-track.scrollLeft)<Math.abs(slides[best].offsetLeft-slides[0].offsetLeft-track.scrollLeft)?i:best,0);gallery.querySelector('[data-gallery-current]').textContent=index+1;prev.disabled=index===0;next.disabled=index===slides.length-1;};
    const go=step=>{const target=Math.min(slides.length-1,Math.max(0,index+step));track.scrollTo({left:slides[target].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    prev.addEventListener('click',()=>go(-1),{signal});next.addEventListener('click',()=>go(1),{signal});track.addEventListener('scroll',sync,{signal,passive:true});sync();
   });
   let observer;
   if(root.matches('[data-sp-reviews]')){
    const layout=()=>root.querySelectorAll('.sp-review:not([hidden])').forEach(card=>{card.style.gridRowEnd='span '+Math.ceil((card.getBoundingClientRect().height+12)/20);});
    observer=new ResizeObserver(layout);
    root.querySelectorAll('.sp-review').forEach(card=>observer.observe(card));
    root.addEventListener('change',layout,{signal});layout();
   }
   instances.set(root,()=>{stopPurchase();abort.abort();observer?.disconnect();instances.delete(root);});
  });
 }
 window.GalileaSlimPatch=init;
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-sp-product],[data-sp-reviews]').forEach(r=>instances.get(r)?.()));
})();
